module.exports = __webpack_public_path__ + "static/media/bg-music.d8c559ae.mp3";